export const api = {
    CARDDETAILS: 'adyen_proxy/paymentMethods/',
    DASHBOARD: 'dashboard/',
    DELETECARD: 'adyen_proxy/storedPaymentMethods/',
    DISPUTES: 'sale_disputes/',
    PAYMENTS: 'adyen_proxy/payments/',
    REFILL: 'adyen_proxy/refill_payments/',
    REFILL_HISTORY: 'credit_refills/',
    REFILL_STATUS: 'credit_refill_status/',
    SESSIONS: 'adyen_proxy/sessions/',

    account: {
        konvives: {
            ADD_PRIVATE_CARD: 'account/konvives/add-private-card',
            DELETE_PRIVATE_CARD: 'account/konvives/delete-private-card',
        },
    },

    auth: {
        ACTIVATION: 'validate-activation-token/',
        ASK_RESET_PASSWORD: 'auth/ask-reset-password',
        LOGIN: 'token/',
        REFRESH_TOKENS: 'token/refresh/',
        REGISTER: 'register/',
        RESET_PASSWORD: 'auth/reset-password',
    },

    catalogue: {
        products: {
            DETAILS: 'catalogue/products/:id/',
            LIST: 'catalogue/products/',
        },
    },

    machines: {
        planograms: {
            DETAILS: 'next/machine_grid_item/:id/',
            LIST: 'next/machine_grid_item/',
        },
    },

    park: {
        sites: {
            LIST: 'park/sites/',
        },
    },

    operations: {
        orders: {
            LIST: 'orders/',
            DETAILS: 'orders/:id/',
        },
    },

    settings: {
        THEME: 'colors_parameters/',
    },

    transactions: {
        sales: {
            DETAILS: 'sales/:id/',
            LIST: 'sales/',
        },
    },

    user: {
        CHECK_CREDIT_CARD: 'user/check-credit-card',
        CONSUME: 'send_notification_to_machine/',
        PROFILE: 'me/',
        UPDATE_PASSWORD: 'password/change/',
    },
}
